export const SIG_SAMPLES = {
    "Node.js": `// npm i express
const crypto = require("crypto");
const express = require("express");
const app = express();
const SECRET = process.env.PAYGATEWAY_WEBHOOK_SECRET;

// IMPORTANT: use the RAW body — re-serialised JSON will not match.
app.post("/webhooks/paygateway", express.raw({ type: "application/json" }), (req, res) => {
  const received = req.get("X-PayGateway-Signature") || "";
  const expected = crypto.createHmac("sha256", SECRET).update(req.body).digest("hex");
  const ok = received.length === expected.length &&
    crypto.timingSafeEqual(Buffer.from(received), Buffer.from(expected));
  if (!ok) return res.status(401).send("invalid signature");

  const event = JSON.parse(req.body.toString("utf8"));
  // De-duplicate: the same event can be delivered more than once.
  // e.g. skip if (event.order_id || event.payout_id) + event.status was already processed.
  res.sendStatus(200);
});

app.listen(3000);`,
    Python: `# pip install flask
import hashlib, hmac, json, os
from flask import Flask, abort, request

app = Flask(__name__)
SECRET = os.environ["PAYGATEWAY_WEBHOOK_SECRET"].encode()

@app.post("/webhooks/paygateway")
def paygateway_webhook():
    raw = request.get_data()  # raw bytes, NOT request.json
    expected = hmac.new(SECRET, raw, hashlib.sha256).hexdigest()
    received = request.headers.get("X-PayGateway-Signature", "")
    if not hmac.compare_digest(expected, received):
        abort(401)

    event = json.loads(raw)
    # De-duplicate on (order_id or payout_id) + status before crediting anything.
    return "", 200`,
    PHP: `<?php
$secret   = getenv('PAYGATEWAY_WEBHOOK_SECRET');
$raw      = file_get_contents('php://input');           // raw body
$received = $_SERVER['HTTP_X_PAYGATEWAY_SIGNATURE'] ?? '';
$expected = hash_hmac('sha256', $raw, $secret);

if (!hash_equals($expected, $received)) {               // constant-time compare
    http_response_code(401);
    exit('invalid signature');
}

$event = json_decode($raw, true);
// De-duplicate on (order_id or payout_id) + status before crediting anything.
http_response_code(200);
echo 'ok';`,
    Java: `// Spring Boot (Java 17+)
import javax.crypto.Mac;
import javax.crypto.spec.SecretKeySpec;
import java.nio.charset.StandardCharsets;
import java.security.MessageDigest;
import java.util.HexFormat;

@RestController
public class PayGatewayWebhook {
  private static final String SECRET = System.getenv("PAYGATEWAY_WEBHOOK_SECRET");

  @PostMapping(value = "/webhooks/paygateway", consumes = "application/json")
  public ResponseEntity<String> handle(@RequestBody byte[] raw,
      @RequestHeader(value = "X-PayGateway-Signature", defaultValue = "") String received) throws Exception {
    Mac mac = Mac.getInstance("HmacSHA256");
    mac.init(new SecretKeySpec(SECRET.getBytes(StandardCharsets.UTF_8), "HmacSHA256"));
    String expected = HexFormat.of().formatHex(mac.doFinal(raw));

    if (!MessageDigest.isEqual(expected.getBytes(StandardCharsets.UTF_8),
                               received.getBytes(StandardCharsets.UTF_8))) {
      return ResponseEntity.status(401).body("invalid signature");
    }
    // Parse raw with Jackson; de-duplicate on (order_id or payout_id) + status.
    return ResponseEntity.ok("ok");
  }
}`,
};
